import { useCurrentRoleStore } from '~/stores/currentRole'

export const useSyncCurrentRole = () => {
  const user = useSupabaseUser()
  const currentRoleStore = useCurrentRoleStore()
  const { memberships, isSystemAdmin, load, clear } = useSchoolMemberships()

  watch(
    () => user.value?.id,
    async (userId) => {
      if (!userId) {
        clear()
        currentRoleStore.setCurrentRole({} as SchoolRole)
        return
      }
      await load(true)
    },
    { immediate: true },
  )

  watch(
    memberships,
    (schoolRoles) => {
      if (!schoolRoles?.length) {
        currentRoleStore.deleteCurrentRole()
        return
      }

      const currentRole = currentRoleStore.currentRole
      const selectedRole = schoolRoles.find(
        (schoolRole) =>
          schoolRole.schoolId === currentRole?.schoolId &&
          schoolRole.role === currentRole?.role,
      )

      if (selectedRole) {
        currentRoleStore.setCurrentRole(selectedRole)
        return
      }

      if (schoolRoles.length === 1 || isSystemAdmin.value) {
        currentRoleStore.setCurrentRole(schoolRoles[0]!)
        return
      }

      // A role must be selected explicitly when an account has multiple roles.
      currentRoleStore.setCurrentRole({} as SchoolRole)
    },
    { deep: true, immediate: true },
  )
}
